'use strict';

angular.module('msCore').service('preloader', ['$q', function ($q) {

  function preloadImageUrlString(image) {
    var imageObject = new Image();
    var deferred = $q.defer();
    imageObject.onload = function () {
      image = imageObject.src;
      deferred.resolve(image);
      return deferred.promise;
    };
    imageObject.src = image;
  }

  function preloadImages(arrayOrString) {
    if (angular.isArray(arrayOrString)) {
      arrayOrString.forEach(function (imageString) {
        preloadImageUrlString(imageString);
      });
    } else {
      preloadImageUrlString(arrayOrString);
    }
  }

  return {
    preloadImageUrlString: preloadImageUrlString,
    preloadImages: preloadImages
  };
}]);